export default {"src":"/_next/static/media/IrritableBowelSyndrome.d0b6701a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};